import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';

@Injectable({
  providedIn: 'root'
})
export class ControlService extends ApiService {

  public collection = '';

  constructor(private http: HttpClient) {
    super(http);
  }



}
